/**
 * Formula-group card body: expression in mono, window + layers + weight
 * as quiet chips.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { CalendarRange, Scale } from 'lucide-react';

import type { ReviewItem } from '../validate/review-items';

const ReviewFormulaBody: FC<{ item: ReviewItem }> = ({ item }) => {
  const group = item.formulaGroup;
  if (!group) return null;
  const weight =
    typeof item.weight === 'number'
      ? `${item.weight}`
      : item.weight
        ? Object.entries(item.weight)
            .map(([layer, value]) => `${layer} ${value}`)
            .join(' · ')
        : null;
  return (
    <div className="space-y-1">
      <code className="block truncate rounded bg-muted/60 px-1.5 py-0.5 font-mono text-[11px]">
        {group.expression || '(sliders)'}
      </code>
      <div className="flex flex-wrap items-center gap-2 text-[10px] text-muted-foreground">
        <span className="inline-flex items-center gap-1">
          <CalendarRange className="h-3 w-3" aria-hidden />
          {group.dateRange}
        </span>
        <span>{group.appliesTo?.join(', ') ?? 'all layers'}</span>
        {weight ? (
          <span className="inline-flex items-center gap-1">
            <Scale className="h-3 w-3" aria-hidden />
            weight {weight}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default ReviewFormulaBody;
